"use client"
import { cn } from '@/lib/utils';
import React from 'react';

// Interface redéfinie pour le type des items
export interface TimelineItem {
  id: string;
  position: 'left' | 'right';
  title: string;
  description: string;
  imageUrl: string;
  alt: string;
}

// Contexte principal pour les tensesurs
export function TimelinesContext({ items }: { items: TimelineItem[] }) {
  return null;
}

// Composant de la ligne verticale principale
const VerticalLine = ({ className }: { className?: string }) => (
  <div className={`absolute h-full w-1 bg-gray-200 left-[10px] md:left-1/2 transform md:-translate-x-1/2 ${className}`}>
  </div>
);

// Composant du point de départ (gauche)
const StartPoint = () => (
  <div className="w-6 h-6 rounded-full bg-bleu-marine mb-8 z-10">
    {/* Code original */}
  </div>
);

// Composant du point d'arrive (droit)
const EndPoint = () => (
  <div className="w-6 h-6 rounded-full bg-bleu-marine z-10">
    {/* Code original */}
  </div>
);

// Composant de la case centrée avec le point
const CenterDot = ({ className }: { className?: string }) => (
  <div className={cn("w-4 h-4 bg-bleu-marine rounded-full z-10 left-[15px]", className)}></div>
);

// Composant du contenu de l'item avec l'arroba et les détails
const ItemTimelineContent = ({ position, item }: { position: 'left' | 'right'; item: TimelineItem }) => (
  <>
    {/* Arroba */}
    <div className={`w-full md:w-5/12 bg-white rounded-md p-4 ${position === 'left' ? 'order-1' : 'order-2'}`}>
      {/* Content */}
      <h3 className="text-xl font-bold mb-4 text-bleu-marine">{item.title}</h3>
      <div className="mb-8">
        <img
          src={item.imageUrl}
          alt={item.alt}
          className="w-full h-auto rounded"
        />
      </div>
      <p className="text-gray-700 mb-4">{item.description}</p>
    </div>

    {/* Point centré */}
    <CenterDot className={`${position === 'left' ? 'md:order-2' : 'md:order-1'}`} />
  </>
);

// Composant principal de la timeline
export function VerticalTimeline({ items }: { items: TimelineItem[] }) {
  return (
    <div className="w-full max-w-4xl mx-auto p-6">
      <div className="relative flex flex-col md:items-center">
        {/* Timeline vertical line */}
        <VerticalLine />

        {/* Start point */}
        <StartPoint />

        {/* Timeline items */}
        {items.map((item, index) => (
          <div key={item.id} className={`flex w-full mb-16 gap-[20px] md:gap-[63px] ${item.position === 'right' ? 'md:justify-end' : 'md:justify-start'}`}>
            <ItemTimelineContent position={item.position} item={item} />
          </div>
        ))}

        {/* End point */}
        <EndPoint />
      </div>
    </div>
  );
}
export default VerticalTimeline;